import { useLocation } from 'react-router-dom';

function useLocationState<T = unknown>() {
  const { state } = useLocation() as any;
  return state as Partial<T> | null;
}

export default useLocationState;
